import { DatePipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideConfig } from '@spartacus/core';
import { defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront';
import { CookieModule, CookieService } from 'ngx-cookie';
import { NewsService } from '../service/news/news.service';

@NgModule({
  declarations: [],
  imports: [CookieModule.forRoot()],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    DatePipe,
    TitleCasePipe,
    NewsService,
    CookieService,
  ],
})
export class SpartacusConfigurationModule {}
